import { WaitOnWebauthNotification } from '@core/usecase/waitOnWebauthNotification';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { ConnectionStateEnum } from '../login/services/dtos/connection-response';
import { AccountsService } from '../select-accounts/services/accounts.service';

export class WaitOnExternalBankLoginVM {
  constructor(
    private processEventService: ProcessEventService,
    private storeService: StoreService,
    private accountService: AccountsService,
    private waitOnWebauthNotification: WaitOnWebauthNotification
  ) {}

  async onInit() {
    await this.waitOnNewBankConnectionNotification();
  }

  async waitOnNewBankConnectionNotification() {
    try {
      const result = await this.waitOnWebauthNotification.execute({
        userId: this.storeService.getVariableOrThrow('USER_ID'),
        userToken: this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN'),
      });

      if (result.success === false) {
        if (result.reason != 'STOP_POLLING_VIA_USER_ACTION') {
          this.processEventService.push(ProcessEventFactory.SpawnAskToRetryWebauth());
        }
        return;
      }

      const newBankConnection = result.value;

      if (newBankConnection.state === ConnectionStateEnum.VALID) {
        this.accountService
          .getAccounts({
            userId: this.storeService.getVariableOrThrow('USER_ID'),
            userToken: this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN'),
            connectionId: newBankConnection.connectionId,
          })
          .subscribe({
            next: (accountsDto) => {
              this.processEventService.push(ProcessEventFactory.SpawnAccountsFoundEvent(accountsDto));
              this.storeService.setVariable('SELECTED_CONNECTION_ID', newBankConnection.connectionId);
            },
            error: (error) => {
              this.processEventService.push(
                ProcessEventFactory.SpawnInternalErrorEvent({
                  error,
                  errorOrigin: 'WaitOnExternalBankLoginVM - getAccounts - error',
                })
              );
            },
          });
      } else {
        this.processEventService.push(ProcessEventFactory.SpawnAskToRetryWebauth());
      }
    } catch (error) {
      this.processEventService.push(
        ProcessEventFactory.SpawnInternalErrorEvent({
          errorOrigin: 'WaitOnExternalBankLoginVM - waitOnNewBankConnectionNotification - catch',
          error,
        })
      );
    }
  }

  backToBankChoice() {
    this.waitOnWebauthNotification.stop();
    this.processEventService.push(ProcessEventFactory.SpawnGoBackToBankChoiceEvent());
  }
}
